import api from 'api'
import { z } from 'zod'

export const createWorkerSubmissionRequestSchema = z.object({
  associationId: z.number(),
  reason: z.string(),
})

export type CreateWorkerSubmissionRequest = z.infer<
  typeof createWorkerSubmissionRequestSchema
>

export const createWorkerSubmissionRequest = async (
  request: CreateWorkerSubmissionRequest
): Promise<void> => {
  const parsedRequest = createWorkerSubmissionRequestSchema.parse(request)

  await api.post('/admin/dayforce/create_worker_submission', {
    associationId: parsedRequest.associationId,
    reason: parsedRequest.reason,
  })
}
